<template>
  <div
    v-if="filteredExistence.length > 0"
    class="main-pcLogisticExistenceItem"
  >
    <div class="content-logistic-list-item__accordion-content--component">
      <UCAcordeon
        :items="filteredExistence"
        title-option="NombreAgrupacion"
        class="mainAcordeon-merchandise-movements mainAcordeon"
        :show-checkbox="false"
        :show-badge="false"
        :closed="true"
        :opened-index="0"
        font-color="#fff"
        primary="var(--his-slate-blue)"
        :after-title="false"
        :search-with-checkbox="false"
        :uncheck-all-items-on-event-accordion-close="false"
      >
        <template #after="option">
          <img
            src="@/static/icons/ic_deleteGris.svg"
            width="30px"
            @click="DeleteExistence(option)"
          >
        </template>
        <template #subOptionSubtitle="{ item }">
          <f7-list
            media-list
          >
            <f7-list-item
              checkbox
              link="#"
              class="content-logistic-item-acordeon-list"
              :checked="item.checked"
              @click="SelectItem(item)"
            >
              <template #root-start>
                <span class="content-logistic-item-acordeon-list__span background-blue">
                  {{ `${$t('common.stocks').toUpperCase()}: ${item.CantidadFinal} ${$t('common.of')} ${item.CantidadTotal}` }}
                </span>
              </template>

              <template #title>
                <div class="span-title">
                  {{ item.Articulo.Nombre }}
                </div>
              </template>

              <div class="item-subtitle">
                {{ item.Articulo.Codigo }}
              </div>

              <template #after>
                <div>
                  <img
                    class="btnOptions"
                    src="@/static/icons/ic_options_blue_background.svg"
                    width="27"
                    @click="SelectMerchadise(item.Articulo, item.Almacen)"
                  >
                  <img
                    class="btnNext"
                    src="@/static/icons/ic_arrow_blue.svg"
                    width="27"
                    @click="OpenActionBatch(item)"
                  >
                </div>
              </template>
            </f7-list-item>
          </f7-list>
        </template>
      </UCAcordeon>
    </div>
    <PCLogisticExistenceLocation
      ref="PCLogisticExistenceLocationPopup"
      :existencias="accumulatedForLocation"
      @change-value="ChangeQuantityItem"
      @popup:closed="showLocationComponent = false"
    />
    <f7-actions
      class="logistic-existence-item-actions-sheet"
      :opened="actionChangesOpened"
      @actions:closed="actionChangesOpened = false"
    >
      <f7-block>
        <div
          v-if="accumulatedStockSelected.length > 0"
          class="content-action-sheet-logistic-existence--items text-align-center"
        >
          <span class="content-action-sheet-logistic-existence--items__title">
            {{ $t('production.common.enterQuantity') }}
          </span>
          <f7-stepper
            :key="accumulatedStockSelected[0].Id"
            fill
            class="content-action-sheet-logistic-existence--items__stepper"
            :min="0"
            :max="accumulatedStockSelected.reduce((total, item) => total + item.CantidadTotal, 0)"
            :manual-input-mode="true"
            :value="accumulatedStockSelected.reduce((total, item) => total + item.CantidadFinal, 0)"
            @input="valorInputCantidad = $event.target.value"
          />
        </div>
        <div class="content-action-sheet-logistic-existence--items__buttons">
          <a
            class=""
            @click="actionChangesOpened = false"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </a>
          <a
            class="color-blue aceptar-button"
            @click="ChangeValueStepper(); actionChangesOpened = false"
          >
            {{ $t('common.accept').toUpperCase() }}
          </a>
        </div>
      </f7-block>
    </f7-actions>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState, mapWritableState } from 'pinia';
import { useWarehouseStore } from '@/js/stores/warehouse';
import { Log } from '@/js/common/HIDebuggingSupport';
import { PreloaderGH } from '@/js/common/HINotificationSupport';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import PCLogisticExistenceLocation from './PCLogisticExistenceLocation.vue';

export default defineComponent({
  name: 'PCLogisticExistenceItem',
  components: {
    UCAcordeon,
    PCLogisticExistenceLocation,
  },

  data() {
    return {
      actionChangesOpened: false,
      valorInputCantidad: 0,
      dataExistence: [],
      showLocationComponent: false,
      selectedItem: [],
      selectedItemForLocation: [],
    };
  },
  computed: {
    accumulatedStockSelected() {
      return this.selectedItem ?? [];
    },

    accumulatedForLocation() {
      return this.selectedItemForLocation ?? [];
    },

    filteredExistence() {
      return this.dataExistence.length > 0 ? this.dataExistence : [];
    },

    ...mapState(useWarehouseStore, [
      'listaExistenciasMovMerc',
    ]),
    ...mapWritableState(useWarehouseStore, ['listaExistenciasMovMerc']),

  },
  watch: {
    listaExistenciasMovMerc(val) {
      if (val && val.length > 0) {
        this.FilterData();
      }
    },
  },

  methods: {
    ChangeQuantityItem() {
      Log(this, this.ChangeQuantityItem.name);
      this.FilterData();
    },

    OpenActionBatch(value) {
      Log(this, this.OpenActionBatch.name);
      this.selectedItem = this.listaExistenciasMovMerc.filter((f) => f.Articulo.Id === value.Articulo.Id && f.Partida.Id === value.Partida.Id && f.Almacen.Id === value.Almacen.Id);

      this.actionChangesOpened = true;
    },
    SelectItem(value) {
      Log(this, this.SelectItem.name);

      if (!this.showLocationComponent && !this.actionChangesOpened) {
        this.selectedItem = this.listaExistenciasMovMerc.filter((f) => f.Articulo.Id === value.Articulo.Id && f.Partida.Id === value.Partida.Id && f.Almacen.Id === value.Almacen.Id);

        value.checked = !value.checked;
        this.UpdateCantidadFinal(value);
        if (value.checked) {
          value.CantidadFinal += value.CantidadTotal;
        }
        // this.valorInputCantidad = value.CantidadFinal;
        // this.AjustarAcumulados();
      }
    },

    SelectMerchadise(articulo, almacen) {
      Log(this, this.SelectMerchadise.name);
      this.selectedItemForLocation = this.listaExistenciasMovMerc.filter((f) => f.Articulo.Id === articulo.Id && f.Almacen.Id === almacen.Id);
      this.showLocationComponent = true;

      this.$refs.PCLogisticExistenceLocationPopup.OpenPopup();
    },

    DeleteExistence(existencia) {
      Log(this, this.DeleteExistence.name);
      this.dataExistence = this.dataExistence.filter((f) => f.AlmacenId !== existencia.AlmacenId);

      this.listaExistenciasMovMerc = this.listaExistenciasMovMerc.filter((f) => f.Almacen.Id !== existencia.AlmacenId);
    },
    UpdateCantidadFinal(item) {
      Log(this, this.UpdateCantidadFinal.name);
      // if (Object.hasOwn(item, 'CantidadFinal') && Object.hasOwn(item, 'CantidadTotal')) return;

      if (!Object.hasOwn(item, 'CantidadFinal')) {
        item.CantidadFinal = 0;
      }
      if (!Object.hasOwn(item, 'CantidadTotal')) {
        item.CantidadTotal = item.Cantidad;
      }

      if (!Object.hasOwn(item, 'Seleccion')) {
        item.Seleccion = item.CantidadFinal;
      }

      if (!item.checked) {
        item.Seleccion = 0;
        item.CantidadFinal = 0;
      }

      if (Number.isInteger(item.CantidadFinal)) {
        Number(item.CantidadFinal);
      } else {
        item.CantidadFinal = Number.parseFloat(item.CantidadFinal.toFixed(2));
      }
    },

    FilterData() {
      Log(this, this.FilterData.name);
      PreloaderGH(true, true, this.$t('common.loadingData'), '');
      const resultado = [];
      const idsAlmacen = [];

      this.listaExistenciasMovMerc.forEach((e) => {
        const { Id: idAlmacen } = e.Almacen;
        const { Nombre: nombreAlmacen } = e.Almacen;
        const { Id: idItem } = e.Articulo;

        const item = e;
        this.UpdateCantidadFinal(item);

        const almacenIndex = idsAlmacen.indexOf(idAlmacen);
        if (almacenIndex === -1) {
          item.CantidadFinal = item.Seleccion;
          idsAlmacen.push(idAlmacen);

          resultado.push({
            AlmacenId: idAlmacen,
            NombreAgrupacion: nombreAlmacen,
            items: [item],
          });
        } else {
          const indexItem = resultado[almacenIndex].items.findIndex((f) => f.Articulo.Id === idItem);

          if (indexItem === -1) {
            this.UpdateCantidadFinal(item);

            resultado[almacenIndex].items.push(item);
          } else {
            this.UpdateCantidadFinal(resultado[almacenIndex].items);
            resultado[almacenIndex].items[indexItem].CantidadFinal += item.Seleccion;
            resultado[almacenIndex].items[indexItem].CantidadTotal += item.Cantidad;

            if (Number.isInteger(resultado[almacenIndex].items[indexItem].CantidadTotal)) {
              Number(resultado[almacenIndex].items[indexItem].CantidadTotal);
            } else {
              resultado[almacenIndex].items[indexItem].CantidadTotal = Number.parseFloat((resultado[almacenIndex].items[indexItem].CantidadTotal).toFixed(2));
            }
          }
        }
      });

      this.dataExistence = resultado;

      PreloaderGH(false);
    },
  },
});
</script>

<style lang="scss">
.main-pcLogisticExistenceItem {
  background: white;

  .accordion-item > .item-link {
    background-color: var(--his-slate-blue);
    --f7-list-chevron-icon-color: #fff;
    --f7-list-item-title-font-weight: 600;

    .item-content .item-inner .item-title {
      color: white;
      font-weight: 500;
    }
  }

  .storybook-action-sorted-accordion .accordion-list .sorted-accordion {
    .accordion-item-content .search-list .item-content {
      padding-left: 0;

      .item-checkbox > .icon-checkbox {
        margin-right: 8px;
      }
    }
  }

  .mainAcordeon-merchandise-movements {
    .accordion-list .accordion-item .item-inner .item-link .item-title {
      font-weight: 500;
    }

    .content-logistic-item-acordeon-list {
      .item-link {
        .item-content {
          .item-inner {
            padding-right: 10px;

            .item-title-row {
              padding-right: 2px;

              .item-after {
                .btnNext {
                  margin-left: 10px;
                  -webkit-filter: none;
                }
              }
            }
          }
        }
      }
    }

    .content-logistic-item-acordeon-list__span {
      margin-top: 10px;
      width: 100%;
      display: flex;
      justify-content: center;
      border-radius: 5px;
      padding: 2px 0;
    }

    .span-title {
      font-size: 17px;
      padding-top: 10px;
      font-weight: 600;
      color: var(--his-slate-blue);
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }

    .background-blue {
      background: var(--his-blueberry-mist);
      color: var(--his-slate-blue);
    }

    .background-green {
      background: var(--his-melon-tint);
      color: var(--his-greenlight);
    }

    .background-red {
      background: var(--his-tomate-tint);
      color: var(--his-tomate);
    }
  }
}

.logistic-existence-item-actions-sheet {
  background-color: #fff;

  .content-action-sheet-logistic-existence {
    &--items {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 60px;

      &__title {
        font-size: 18px;
        font-weight: 400;
        padding-bottom: 24px;
        color: var(--his-steel-blue);
      }

      &__buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: white;

        a {
          font-size: 14px;
          font-weight: 400;
        }

        .aceptar-button {
          font-size: 18px;
          font-weight: 500;
        }
      }

      &__stepper {
        --f7-stepper-fill-button-text-color: #fff;
        --f7-stepper-height: 36px;
        --f7-stepper-border-radius: 0px;

        .stepper-input-wrap {
          input {
            width: 100px;
            border: none;
          }
        }

        .actions-label::after {
          height: 0 !important;
        }
      }
    }
  }
}
</style>
